import { Body } from "@/sprout/typography";
import Fingerprint6 from "../../images/fingerprint_6.svg";
import useTranslation from "@/hooks/use_translation";

export const ExpandSearchCard = () => {
  const { t } = useTranslation("jobSearch");

  return (
    <div className="flex flex-col pl-3 pr-6 py-6 gap-4 justify-center border-2 rounded-lg border-solid border-gray-00 bg-white">
      <div className="flex justify-center items-center gap-[10px]">
        <img
          src={Fingerprint6}
          alt="Greenhouse fingerprint leaf"
          className="flex-1 min-w-12 max-w-[120px] h-auto"
        />
        <div className="flex flex-col justify-center whitespace-nowrap">
          <Body metadata>{t("expandSearch.notWhatLookingFor")}</Body>
          <Body metadata>{t("expandSearch.tryExpandingYourSearch")}</Body>
        </div>
      </div>
    </div>
  );
};
